import { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { UserTypeEnum } from "../../../_common/enum/userType.enum";
import { StandardList } from "../../../_components/list/standardList.component";
import { StandardListItem } from "../../../_components/list/standardListItem.component";
import { SECONDARY_COLOR, SUCCESS_COLOR, WARNING_COLOR } from "../../../_const/color.const";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import {
    extractTicketQueryMetadata,
    formatTicketQueryMetadata,
    stripTicketQueryContent,
    truncateTicketQueryPreview,
} from "../../../_helpers/ticketQuery.helper";
import { accountService } from "../../../_services/accounts.service";
import { ticketQueryService } from "../../../_services/ticketQuery.service";
import { TicketQueryDrawer } from "./ticket-queryDrawer";

export function TicketQueryList(params: { refreshCounter: number }) {

    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<any[]>([]);
    useEffect(() => {
        fetchData();
    }, [id]);

    useEffect(() => {
        if (params.refreshCounter > 0)
            fetchData();
    }, [params.refreshCounter]);

    function fetchData() {
        if (!id) return;
        setIsLoading(true);
        return ticketQueryService
            .getAll(id)
            .then(
                (json) => {
                    setData(json);
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function getBackGroundColour(userTypeId: any) {
        if (userTypeId === UserTypeEnum.Agent)
            return { primary: SUCCESS_COLOR, hover: "green" };

        if (userTypeId === UserTypeEnum.Client)
            return { primary: SECONDARY_COLOR, hover: WARNING_COLOR };

    }

    return (

        <>
            <StandardList isLoading={isLoading}>
                {(!isLoading && !!data.length) && data.map((item: any, index: number) => {
                    const question = stripTicketQueryContent(item?.question);
                    const questionMeta = formatTicketQueryMetadata(extractTicketQueryMetadata(item?.question));
                    return (
                    <StandardListItem
                        sx={{
                            backgroundColor: getBackGroundColour(item.userTypeId)?.primary, //Red background for public Actions
                            '&:hover': {
                                backgroundColor: getBackGroundColour(item.userTypeId)?.hover, //Red background for public Actions
                            },
                        }}
                        primary={`Q: ${truncateTicketQueryPreview(question)}`}
                        primarySubline={questionMeta || undefined}
                        tertiary={`Resolved: ${item.isResolved === true ? "Yes" : " No"}`}
                        buttons={
                            accountService.isAdmin ?
                                [
                                    { icon: item.isCompleted ? "visibility" : "edit", onClick: () => { navigate(`ManageQueries/Update/${item.id}`) }, variant: "primary" },
                                ] :
                                [
                                    { icon: "visibility", onClick: () => { navigate(`ManageQueries/Update/${item.id}`) }, variant: "primary" },
                                ]
                        }
                        key={item.id}

                    />
                );
                })}

            </StandardList>
            <Routes>
                <Route path="ManageQueries/*" element={<TicketQueryDrawer onSave={() => { fetchData(); navigate(""); }} onClose={() => { navigate(""); }} />} />
            </Routes>
        </>
    );
}
